/**
 * AuthCallback — the SPA landing spot after the server's OAuth callback set the
 * auth cookie and redirected here with ?name=&email=. It confirms the session
 * via AuthContext.login and forwards to the dashboard. Ported from the Receipts
 * app (client/src/pages/AuthCallback.jsx), trimmed for the no-roles model.
 */

import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { login } = useAuth();

  useEffect(() => {
    const email = params.get('email');
    const name = params.get('name');
    if (email) {
      // The HttpOnly cookie is already set by the server; hydrate the client
      // user object and proceed.
      login({ email, name, avatar_url: null });
      navigate('/', { replace: true });
    } else {
      navigate('/login?error=oauth_failed', { replace: true });
    }
    // login/navigate are stable; params is read once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', color: 'var(--color-text-muted)' }}>
      Signing you in…
    </div>
  );
}
